import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import { styleVariables } from '@lib/common';
import { styled } from '@xstyled/styled-components';
import { getDateTime } from '../utils';
import { ShareContent } from './share-content.component';
import { useCallback } from 'react';
import { AssignmentType } from '@module/assignment';
import { Typography } from 'antd';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var Text = Typography.Text;
var StyledInformation = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 16px 16px 16px 0;\n  color: ", ";\n"])), styleVariables.colors.gray10);
export var SuccessModalContent = function SuccessModalContent(props) {
  var assignmentInfo = props.assignmentInfo,
      sharedLink = props.sharedLink,
      label = props.label,
      shareAssignmentTranslation = props.shareAssignmentTranslation;
  var id = assignmentInfo.id,
      type = assignmentInfo.type,
      startTime = assignmentInfo.startTime,
      endTime = assignmentInfo.endTime,
      description = assignmentInfo.description,
      idNumber = assignmentInfo.idNumber;
  var translateAssignmentNameByType = useCallback(function (type) {
    switch (type) {
      case AssignmentType.Practice:
        {
          return label.practice;
        }

      case AssignmentType.Homework:
        {
          return label.homework;
        }

      case AssignmentType.Examination:
        {
          return label.examination;
        }
    }
  }, []);
  var renderTimestamp = useCallback(function (startTime, endTime) {
    return startTime && endTime ? /*#__PURE__*/_jsxs("span", {
      children: [getDateTime(+parseInt(startTime)), " - ", getDateTime(+parseInt(endTime))]
    }) : /*#__PURE__*/_jsx("span", {
      children: "- -"
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsxs(StyledInformation, {
        children: [/*#__PURE__*/_jsxs(Text, {
          children: [translateAssignmentNameByType(type), " -", ' ', description || shareAssignmentTranslation.noDescription]
        }), /*#__PURE__*/_jsxs("div", {
          children: [shareAssignmentTranslation.durationAssignment, ": ", renderTimestamp(startTime, endTime)]
        })]
      })
    }), /*#__PURE__*/_jsx(ShareContent, {
      sharedLink: sharedLink,
      assignmentId: id.toString(),
      idNumber: idNumber,
      shareAssignmentTranslation: shareAssignmentTranslation
    })]
  });
};